/**
 * Action types for chat history feature
 */
/**
 * Action to set the visibility of the chat history panel
 */
export const SET_CHAT_HISTORY_VISIBLE = 'SET_CHAT_HISTORY_VISIBLE';
/**
 * Action to set the chat history data
 */
export const SET_CHAT_HISTORY_DATA = 'SET_CHAT_HISTORY_DATA';
/**
 * Action to set the selected conversation
 */
export const SET_SELECTED_CONVERSATION = 'SET_SELECTED_CONVERSATION';
/**
 * Action to set the list of conversations
 */
export const SET_CONVERSATIONS_LIST = 'SET_CONVERSATIONS_LIST';
/**
 * Action to set polling state
 */
export const SET_CHAT_HISTORY_POLLING = 'SET_CHAT_HISTORY_POLLING';
/**
 * Action to set loading state
 */
export const SET_CHAT_HISTORY_LOADING = 'SET_CHAT_HISTORY_LOADING';
/**
 * Action to set error state
 */
export const SET_CHAT_HISTORY_ERROR = 'SET_CHAT_HISTORY_ERROR';
/**
 * Action to add new messages
 */
export const ADD_CHAT_HISTORY_MESSAGES = 'ADD_CHAT_HISTORY_MESSAGES';
/**
 * Action to set last update timestamp
 */
export const SET_CHAT_HISTORY_LAST_UPDATED = 'SET_CHAT_HISTORY_LAST_UPDATED';
/**
 * Live STT: upsert the in-progress (interim) line for a participant.
 */
export const STT_UPSERT_INTERIM = 'STT_UPSERT_INTERIM';
/**
 * Live STT: commit a final line (append to the log, clear that participant's interim).
 */
export const STT_COMMIT_FINAL = 'STT_COMMIT_FINAL';
/**
 * Live STT: clear all accumulated transcripts and interims.
 */
export const STT_CLEAR_TRANSCRIPTS = 'STT_CLEAR_TRANSCRIPTS';
/**
 * AI response: append a streaming chunk (keyed by generation_id) — concatenate.
 */
export const AI_RESPONSE_APPEND = 'AI_RESPONSE_APPEND';
/**
 * AI response: commit the final full text (replace the streaming line).
 */
export const AI_RESPONSE_FINAL = 'AI_RESPONSE_FINAL';
